import { takeLatest, put } from "redux-saga/effects";
import accountSlice, { REJECT_TERMS } from "store/account/slice";
import { rejectTermsAndConditions } from "resources/services/userService";

function* fetch({ payload, meta }) {
  const { uid, url } = payload;
  const { error, success } = accountSlice.actions;
  try {
    const response = yield rejectTermsAndConditions(uid, url);
    meta?.onSuccess && meta.onSuccess(response);

    yield put(success());
  } catch (e) {
    yield put(error(e));
  }
}

export default function* watchRejectTerms() {
  yield takeLatest(REJECT_TERMS.type, fetch);
}
